const Menu = {
    classNames: {
        active: 'menu--active',
        open: 'menu--open',
        visible: 'menu--visible',
        flyoutItems: 'header-global__flyout__item',
        headerInner: 'header-global__inner-wrapper',
        hamburger: 'header-global__nav__mobile-menu-icon',
        navLink: 'header-global__nav__list-item-link'
    },
    instance: document.querySelector('.header-global'),
    open(ev) {
        if (this.instance) {
            const id = ev.target.dataset.openMenu;
            const menu = this.instance.querySelector(`[data-menu-id="${id}"]`);
            this.reset([this.classNames.active, this.classNames.open]);
            ev.target.classList.add(this.classNames.active);
            menu.classList.add(this.classNames.open);
        }
    },
    close() {
        if (this.instance) {
            this.reset([this.classNames.active, this.classNames.open]);
        }
    },
    reset(evs) {
        if (this.instance) {
            evs.forEach(ev => {
                const elements = this.instance.getElementsByClassName(ev);
                while (elements[0]) {
                    elements[0].classList.remove(ev);
                }
            });
        }
    },
    init() {
        if (this.instance) {
            const openers = this.instance.querySelectorAll('[data-open-menu]');
            const html = document.querySelector('html');
            const header = document.querySelectorAll(`.${this.classNames.flyoutItems}, .${this.classNames.headerInner}, .${this.classNames.hamburger}`);
            openers.forEach(opener => {
                opener.addEventListener('click', ev => {
                    ev.preventDefault();
                    if (ev.target.classList.contains(this.classNames.active)) {
                        this.close();
                    } else {
                        this.open(ev);
                    }
                });
            });
            html.addEventListener('click', ev => {
                if (!ev.target.classList.contains(this.classNames.navLink)) {
                    this.close();
                }
            });
            header.forEach(flyout => {
                flyout.addEventListener('click', ev => {
                    ev.stopPropagation();
                });
            });
        }
    }
};

export default Menu;
